import { createSlice } from '@reduxjs/toolkit';

const eventsSlice = createSlice({
  name: 'events',
  initialState: {
    checkedItems: [],
    activeEventsTab: 'Wydarzenia',
    currentPage: 1,
    maxPages: 2,
    sortBy: 'added_on',
    sortDirection: 'DESC',
    filterQuery: 'ALL',
    keyword: null,
    searchValue: '',
    addModalOpen: false,
    editModalOpen: false,
    editedEvent: null,
    needRefresh: 1,
    modalViewActualTab: 'Dane podstawowe',
    addEventMode: false,
    duplicatedEventId: null,
    editModalMode: 'preview',
    visibleEventIds: [],
  },
  reducers: {
    setEditedEvent(state, action) {
      state.editedEvent = action.payload;
    },
    setCheckedItems: (state, action) => {
      state.checkedItems = action.payload;
    },
    toggleCheckedItem: (state, action) => {
      const id = action.payload;
      if (state.checkedItems.includes(id)) {
        state.checkedItems = state.checkedItems.filter((item) => item !== id);
      } else {
        state.checkedItems.push(id);
      }
    },
    setPage(state, action) {
      state.checkedItems = [];
      state.currentPage = action.payload;
    },
    setMaxPages(state, action) {
      state.maxPages = action.payload;
    },
    setSorting(state, action) {
      state.checkedItems = [];
      const { sortBy, sortDirection } = action.payload;
      state.sortBy = sortBy;
      state.sortDirection = sortDirection;
    },
    setFilterQuery(state, action) {
      state.checkedItems = [];
      state.filterQuery = action.payload;
    },
    toggleNeedRefresh: (state) => {
      state.needRefresh = state.needRefresh === 1 ? 0 : 1;
    },
    toggleAddModal(state) {
      state.addModalOpen = !state.addModalOpen;
    },
    toggleEditModal(state) {
      state.editModalOpen = !state.editModalOpen;
    },
    setKeyword: (state, action) => {
      state.keyword = action.payload;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    setModalViewActualTab(state, action) {
      state.modalViewActualTab = action.payload;
    },
    setAddEventMode(state, action) {
      state.addEventMode = action.payload;
    },
    setDuplicatedEventId(state, action) {
      state.duplicatedEventId = action.payload;
    },
    clearDuplicatedEventId(state) {
      state.duplicatedEventId = null;
    },
    setEditModalMode(state, action) {
      state.editModalMode = action.payload;
    },
    setVisibleEventIds(state, action) {
      state.visibleEventIds = action.payload;
    },
  },
});

export const {
  setEditedEvent,
  setCheckedItems,
  toggleCheckedItem,
  setPage,
  setMaxPages,
  setSorting,
  setFilterQuery,
  toggleAddModal,
  toggleEditModal,
  toggleNeedRefresh,
  setKeyword,
  setSearchValue,
  setModalViewActualTab,
  setAddEventMode,
  setDuplicatedEventId,
  clearDuplicatedEventId,
  setEditModalMode,
  setVisibleEventIds,
} = eventsSlice.actions;

export default eventsSlice.reducer;
